import { createSlice } from "@reduxjs/toolkit";
import { addNewModel, createModelImages, createModelVideos, generateModelImage, getAutoGeneratedMedia, getModelAnalytics, getMyModel, getMyModelDetails } from "./thunk";

const initialState = {
  models: [],//for dashboard
  modelData: [],//for model by id
  generateModelLoading: false,
  generatedImage: null,
  addModelLoading: false,
  modelsLoading: false,
  error: null,
};

const modelSlice = createSlice({
  name: "model",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetModelData: (state) => {
      state.generatedImage = null;
      state.addModelLoading = false;
      state.modelData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ------------------------------------------------------generate model image/face
      .addCase(generateModelImage.pending, (state) => {
        state.generateModelLoading = true;
        state.error = null;
      })
      .addCase(generateModelImage.fulfilled, (state, action) => {
        state.generateModelLoading = false;
        state.generatedImage = action.payload;
      })
      .addCase(generateModelImage.rejected, (state, action) => {
        state.generateModelLoading = false;
        state.error = action.payload;
      })

      // ------------------------------------------------------add/save model
      .addCase(addNewModel.pending, (state) => {
        state.addModelLoading = true;
        state.error = null;
      })
      .addCase(addNewModel.fulfilled, (state, action) => {
        state.addModelLoading = false;
        state.models = action.payload;
      })
      .addCase(addNewModel.rejected, (state, action) => {
        state.addModelLoading = false;
        state.error = action.payload;
      })

      // ------------------------------------------------------get models
      .addCase(getMyModel.pending, (state) => {
        state.modelsLoading = true;
        state.error = null;
      })
      .addCase(getMyModel.fulfilled, (state, action) => {
        state.modelsLoading = false;
        state.models = action.payload;
      })
      .addCase(getMyModel.rejected, (state, action) => {
        state.modelsLoading = false;
        state.error = action.payload;
      })

      // ------------------------------------------------------get model by id
      .addCase(getMyModelDetails.pending, (state) => {
        state.modelsLoading = true;
        state.error = null;
      })
      .addCase(getMyModelDetails.fulfilled, (state, action) => {
        state.modelsLoading = false;
        state.modelData = action.payload;
      })
      .addCase(getMyModelDetails.rejected, (state, action) => {
        state.modelsLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------get model analytics by id
      .addCase(getModelAnalytics.pending, (state) => {
        state.modelsLoading = true;
        state.error = null;
      })
      .addCase(getModelAnalytics.fulfilled, (state, action) => {
        state.modelsLoading = false;
        state.modelData = action.payload;
      })
      .addCase(getModelAnalytics.rejected, (state, action) => {
        state.modelsLoading = false;
        state.error = action.payload;
      })

      // ------------------------------------------------------create Model images
      .addCase(createModelImages.pending, (state) => {
        state.modelsLoading = true;
        state.error = null;
      })
      .addCase(createModelImages.fulfilled, (state, action) => {
        state.modelsLoading = false;
        state.models = action.payload;
      })
      .addCase(createModelImages.rejected, (state, action) => {
        state.modelsLoading = false;
        state.error = action.payload;
      })

      // ------------------------------------------------------create Model videos
      .addCase(createModelVideos.pending, (state) => {
        state.modelsLoading = true;
        state.error = null;
      })
      .addCase(createModelVideos.fulfilled, (state, action) => {
        state.modelsLoading = false;
        state.models = action.payload;
      })
      .addCase(createModelVideos.rejected, (state, action) => {
        state.modelsLoading = false;
        state.error = action.payload;
      })
      
       // ------------------------------------------------------get auto genberated media
      .addCase(getAutoGeneratedMedia.pending, (state) => {
        state.modelsLoading = true;
        state.error = null;
      })
      .addCase(getAutoGeneratedMedia.fulfilled, (state, action) => {
        state.modelsLoading = false;
        state.modelData = action.payload;
      })
      .addCase(getAutoGeneratedMedia.rejected, (state, action) => {
        state.modelsLoading = false;
        state.error = action.payload;
      })
  },
});

export const { clearError } = modelSlice.actions;
export default modelSlice.reducer;